import { useQuery } from "@tanstack/react-query";
import { fetchAllProductsWithStats, fetchProductDetail } from "@/lib/products";

export function useAdminProducts() {
  return useQuery({
    queryKey: ["products", "admin", "with-stats"],
    queryFn: fetchAllProductsWithStats,
    staleTime: 15_000,
  });
}

export function useAdminProduct(id: string | undefined) {
  return useQuery({
    queryKey: ["products", "admin", "detail", id],
    queryFn: () => fetchProductDetail(id!),
    enabled: Boolean(id),
    staleTime: 10_000,
  });
}
